import React from "react";
import CardNews from "../components/CardNews";
import sirene from "../images/News/Sirene.jpg";
import zumba from "../images/News/Zumba.jpg"
import blackFriday from "../images/News/Black_friday.jpg"
import sanvalentino from "../images/News/Promozioni San Valentino.jpg"
import carnevale from "../images/News/Carnevale/IMG_9635-2.jpg"
import fitness from "../images/News/EventoFitness.jpeg"
import pmarzo from "../images/News/Promo_marzo_2.png"
import barista from "../images/News/Barista.jpg"
import promoFine from "../images/News/Promo_fine_stagione.png"
import preIs_bambini from "../images/PreIscrizioni/25.png"
import preIs_adulti from "../images/PreIscrizioni/24.png"
import preIs_nuoviCorsi from "../images/PreIscrizioni/A3.png"
import ScrollToTopOnMount from "../components/ScrollToTopOnMount";
import Space from "../commons/Space";
import TitoloSezioni from "../commons/TitoloSezioni";
import {Link} from "react-router-dom";
import insta from "../icone/icons8-instagram-48.png";
import facebook from "../icone/icons8-facebook-48.png";
import sanValentinoNews from "./news_pages/SanValentinoNews";

function NewsHome () {
    return(
        <div>
        <div className="card-container flex-row flex-wrap justify-content-center">
            <ScrollToTopOnMount />
            <CardNews foto={preIs_bambini} titolo={"Pre-Iscrizioni nuoto bambini"} descrizione={""} data={"17.06.2024"} indirizzo={"./preiscrizionibambini"} settore1={"piscina"}  posizioneFoto={"top"}/>
            <CardNews foto={preIs_adulti} titolo={"Pre-Iscrizioni nuoto adulti"} descrizione={""} data={"17.06.2024"} indirizzo={"./preiscrizioniadulti"} settore1={"piscina"}  posizioneFoto={"top"}/>
            <CardNews foto={preIs_nuoviCorsi} titolo={"Novità corsi"} descrizione={""} data={"17.06.2024"} indirizzo={"./novità2024"} settore1={"piscina"} settore2={"fitness"} posizioneFoto={"top"}/>
            <CardNews foto={promoFine} titolo={"Promo di fine stagione"} descrizione={""} data={"12.04.2024"} indirizzo={"./promofinestagione"} settore1={"palestra"} settore2={"multitessere"} posizioneFoto={"top"}/>
            <CardNews foto={barista} titolo={"Il Cigno Café"} descrizione={""} data={"11.04.2024"} indirizzo={"./barista"} settore1={"ilcignocafé"} posizioneFoto={"top"}/>
            <CardNews foto={pmarzo} titolo={"Promo marzo"} descrizione={""} data={"03.2024"} indirizzo={"./promomarzo"} settore1={"multitessere"} settore2={"corsinuoto"} posizioneFoto={"top"}/>
            <CardNews foto={fitness} titolo={"Bodyflex e dancegym"} descrizione={""} data={"24.03.2024"} indirizzo={"./eventofitness"} settore1={"fitness"} posizioneFoto={"top"}/>
            <CardNews foto={carnevale} titolo={"Festa di Carnevale"} descrizione={""} data={"17.02.2024"} indirizzo={"./festacarnevale"} settore1={"corsinuoto"} settore2={"runnering"} posizioneFoto={"center"}/>
            <CardNews foto={sanvalentino} titolo={"Promo San Valentino"} descrizione={""} data={"14.02.2024"} indirizzo={"./sanvalentino"} settore1={"palestra"} settore2={"multitessere"} posizioneFoto={"center"}/>
            <CardNews foto={zumba} titolo={"Corso di Zumba"} descrizione={""} data={"01.12.2023"} indirizzo={"./zumba"} settore1={"fitness"} posizioneFoto={"top"}/>
            <CardNews foto={blackFriday} titolo={"Black Friday"} descrizione={"Sconto 30% su abbigliamento e palestra"} data={"18.11.2023"} indirizzo={"./blackFriday"} settore1={"abbigliamento"} settore2={"palestra"} posizioneFoto={"top"} />
            <CardNews foto={sirene} titolo={"Mermaid Experience"} descrizione={""} data={"15.11.2023"} indirizzo={"./sirene"} settore1={"piscina"} posizioneFoto={"center"}/>
            <Space />

        </div>
            <Space />
            <TitoloSezioni title={"Social"} />
            <figure className="text-center" style={{marginTop: "2em"}}>
                <blockquote className="blockquote">
                    <h2>Resta sempre aggiornato</h2>
                    <h3>Seguici su Instagram e Facebook</h3>
                    <p style={{marginTop: "2em"}}>
                        <Link to="https://www.instagram.com/centrosportivoilcigno/?hl=it">
                            <img src={insta}></img>
                        </Link>
                        <Link to="https://www.facebook.com/ilcignosport.it/?locale=it_IT">
                            <img src={facebook}></img>
                        </Link>
                    </p>
                    <br/>
                </blockquote>
            </figure>
            <Space />
        </div>
    )
}
export default NewsHome